
import Link from 'next/link';

import { BracketRound, TournamentResultsByRound, TournamentResultsByRoundItem, TTournamentParams } from '~/../api/common.types';
import Button from '~/components/common/Button';
import Section from '~/components/hero/LandingPage/Section';
import { TOURNAMENTS } from '~/constants';
import { useGetTournamentByes } from '~/hooks/game/useGetTournamentByes';
export const V_TOTAL = 1290;


export const isBigBracket = (matchupByRound: TournamentResultsByRoundItem): boolean => {
  const totalMatchups = matchupByRound.matchups.length * 2;
  return totalMatchups >= 8 && totalMatchups <= 64;
};

export const isSmallBracket = (matchupByRound: TournamentResultsByRoundItem): boolean => {
  const totalMatchups = matchupByRound.matchups.length * 2;
  return totalMatchups > 2 && totalMatchups < 8;
};


export const isFinalsBracket = (matchupByRound: TournamentResultsByRoundItem): boolean => {
  const totalMatchups = matchupByRound.matchups.length * 2;
  return totalMatchups === 2;
};


const generateRoundLogic = (matchupByRound: TournamentResultsByRoundItem): BracketRound => {
  const totalMatchups = matchupByRound.matchups.length * 2;
  const round = matchupByRound.round;
  if (totalMatchups > 64) {
    return {
      label: `Round ${round + 1}`, // zero based
      bracketType: 'grid',
      battleId: round,
      totalMatchups,
    };
  }
  if (isBigBracket(matchupByRound)) {
    return {
      label: '64 -> 8',
      bracketType: 'bracket',
      battleId: round,
      totalMatchups,
    };
  } else if (isSmallBracket(matchupByRound)) {
    return {
      label: 'Final 4',
      bracketType: 'final4',
      battleId: round,
      totalMatchups,
    };
  }
  return {
    label: 'Finals',
    battleId: round,
    bracketType: 'finals',
    totalMatchups,
  };
};

export const generateRoundsLogic = (matchupsByRound: TournamentResultsByRound): BracketRound[] => {
  const rounds: BracketRound[] = [];
  matchupsByRound.map((matchupByRound) => {
    const round = generateRoundLogic(matchupByRound);
    const found = rounds.find((r) => r.label === round.label);
    if (!found) {
      rounds.push(round);
    }
  });
  return rounds;
};


export const MatchupNavigation = ({
  activeRound,
  setActiveRound,
  rounds,
  tournamentParam,
}: {
  activeRound: BracketRound;
  setActiveRound: (activeRound) => void;
  rounds: BracketRound[];
  tournamentParam: TTournamentParams;
}) => {
  const { data: byesData } = useGetTournamentByes({
    data: {
      contextId: TOURNAMENTS[tournamentParam].apiContext,
    },
  });
  const firstRound = rounds.length ? rounds[0].totalMatchups : 0;
  const totalByes = byesData?.length || 0;
  const totalFirstRound = firstRound + totalByes;

  return (
    <>
      <Section className="landing-page__section--tournament_navigation">
        <nav>
          {Object.values(TOURNAMENTS)
            .filter((tournament) => tournament.isShown)
            .map((tournament, index) => (
              <Link
                href={`/tournaments/${tournament.id}`}
                passHref
                key={`link-${index}`}
              >
                <button
                  key={`button-${index}`}
                  className={`button ${
                    tournamentParam === tournament.id ? 'active' : ''
                  }`}
                >
                  <div className="button__secondary-label">
                    <strong>{tournament.name}</strong>
                  </div>
                </button>
              </Link>
            ))}
        </nav>
        {/* matchupsTotal is variable for first round */}
        <nav>
          {Boolean(rounds.length) &&
              rounds.map((round: BracketRound, index: number) => {
                return (
                  <Button
                    key={`button-${index}`}
                    label={
                      <div className="button__secondary-label">
                        <strong>{round.label}</strong>
                        <span>
                          {index === 0 ? totalFirstRound : round.totalMatchups}
                        </span>
                      </div>
                    }
                    onClick={() => {
                      setActiveRound(round);
                    }}
                    className={`button ${
                      activeRound.label === round.label ? 'active' : ''
                    }`}
                  />
                );
              })}
        </nav>
      </Section>
    </>
  );
};
